export const isAbsoluteUrl = (value: string): boolean => {
    return /^(https?|ftp):\/\//i.test(value);
};

export const normaliseSlug = (slug?: string | null): string => {
    if (!slug) {
        return "/";
    }

    const trimmedSlug = slug.trim();

    if (!trimmedSlug) {
        return "/";
    }

    if (isAbsoluteUrl(trimmedSlug)) {
        console.log("isAbsoluteUrl", trimmedSlug);
        return trimmedSlug;
    }

    return `/${trimmedSlug.replace(/^\/+/, "")}`;
};